module.exports = __webpack_public_path__ + "img/bms1.188cd1ad.png";